import { IS_PRODUCTION } from 'constants/system'
import { bookingIdToDiseaseId } from 'constants/diseases'

import { find, get } from 'lodash'
import Container from 'components/Container'
import Cover from 'components/Cover'
import Button from 'components/Button'
import Section from 'components/Section'
import NavigationList from 'components/NavigationList'
import Spinner from 'components/Spinner'
import { BOOKING_TYPES } from 'data/booking'
import useSession from 'hooks/useSession'
import useSWR from 'swr'
import { getPublicOrgUnits } from 'lib/requests'
import Header from 'apps/booking/components/Header'

import Footer from '../components/Footer'

export default function OrgunitIndexPage() {
  const { data: orgUnits } = useSWR('orgUnits', () => getPublicOrgUnits())
  const { isSignedIn, session } = useSession()
  const [, , orgUnit = null, bookingTypeID = null] =
    String(get(session, 'state')).match(/^([^:]+)(?::([^:]+)(?::([A-Z_]+)))?$/) || []
  const bookingType = BOOKING_TYPES[bookingTypeID]

  if (!orgUnits) {
    return <Spinner />
  }

  const orgUnitLinks = orgUnits
    // Hide Reminneapolis in listings (it should only be accessible via a direct link)
    .filter(({ slug }) => !(IS_PRODUCTION && slug === 'reminneapolis'))
    .filter((ou) => {
      const featureDiseaseIds = (ou?.features ?? []).map(bookingIdToDiseaseId)

      return Boolean(
        featureDiseaseIds.find(
          (diseaseId) => ou?.vaccination_properties?.[diseaseId]?.public_booking_enabled ?? false,
        ),
      )
    })
    .map(({ title, slug }) => {
      return { title, link: slug }
    })

  const orgUnitObject = find(orgUnits, { slug: orgUnit })

  return (
    <>
      <Header
        seoTitle="Timebestilling"
        seoDescription="Remin er en tjeneste hvor man kan bestille time for koronatest, koronavaksine og influensavaksine."
      />

      <Cover
        title="Timebestilling"
        size="tight"
        preamble="Remin er en tjeneste hvor man kan bestille time for koronatest, koronavaksine og influensavaksine. Du kan kun ta i bruk tjenesten hvis du bor eller oppholder deg i en av kommunene listet opp under."
      />
      <Container size="tight" style={{ paddingBottom: '3rem' }}>
        {isSignedIn && orgUnit && bookingType ? (
          <Section
            title={`${get(bookingType, 'title')} i ${get(orgUnitObject, 'title', '–')}`}
            type="box"
          >
            <p>
              Du er fortsatt innlogget. Logg ut med krysset opp til høyre om du ønsker å velge en
              annen kommune.
            </p>
            <Button rounded to={`/${orgUnit}/${get(bookingType, 'slug')}`}>
              {bookingType?.id === 'COVID_VACCINE' ? 'Se eller bestill time' : 'Bestill ny time'}
            </Button>
          </Section>
        ) : (
          <Section title="Tilgjengelige kommuner">
            <NavigationList items={orgUnitLinks} />
          </Section>
        )}
        <Footer />
      </Container>
    </>
  )
}
